import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as AwardIcon } from './award.svg';

export const Award = IconHOC(AwardIcon);
